// The SSR seed and the UserProfileSections consumer must pass identical
// variables so they share an Apollo cache key (otherwise the seed is never
// read). Page sizes live as defaults in the .gql documents, so only the id is
// passed here.
const profileSectionsVariables = (id: string | number) => ({ id })

export default profileSectionsVariables
